import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import styles from './SiteFooter.scss';

class SiteFooter extends Component {
  render() {
    return (
      <header className="SiteFooter">
        <div className="SiteFooter__content">
          <section className="SiteFooter__group" data-group="grade">
            <h5 className="SiteFooter__list-title">Browse by Grade</h5>
            <ul className="SiteFooter__list">
              <li className="SiteFooter__item">
                <NavLink to="/pre-k-and-k-playground">
                  Pre-K &amp; Kindergarten
                </NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/1">1st Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/2">2nd Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/3">3rd Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/4">4th Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/5">5th Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/6">6th Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/7">7th Grade</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/grade/8">8th Grade</NavLink>
              </li>
            </ul>
          </section>
          <section className="SiteFooter__group" data-group="type">
            <h5 className="SiteFooter__list-title">Browse by Type</h5>
            <ul className="SiteFooter__list">
              <li className="SiteFooter__item">
                <NavLink to="/games">All Games</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/videos">All Videos</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/books">All Books</NavLink>
              </li>
            </ul>
          </section>
          <section className="SiteFooter__group" data-group="about">
            <h5 className="SiteFooter__list-title">About Funbrain</h5>
            <ul className="SiteFooter__list">
              <li className="SiteFooter__item">
                <NavLink to="/teachers-and-parents">Teachers &amp; Parents</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/advertise-with-funbrain">Advertise With Us</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/about">About</NavLink>
              </li>
              <li className="SiteFooter__item">
                <NavLink to="/terms-of-use">Terms of Use</NavLink>
              </li>
              <li className="SiteFooter__item">
                <br />
                <NavLink to="/privacy-policy">
                  <strong>Privacy Policy</strong>
                </NavLink>
              </li>
              <li className="SiteFooter__item">
                &copy;2020 Funbrain Holdings, LLC
              </li>
            </ul>
          </section>
        </div>
      </header>
    );
  }
}

export default SiteFooter;
